import * as types from './actions/types'

const initialState = {
  loading: false,
  error: null,
  infoMessage: '',
  report: null,
  lastUpdated: null,
  downloading: false,
  downloadError: null,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_REPORT:
      return {
        ...state,
        loading: true,
        error: null,
        infoMessage: '',
      }
    case types.FETCH_REPORT_FULFILLED:
      return {
        ...state,
        loading: false,
        report: action.payload?.report ?? null,
        infoMessage: action.payload?.infoMessage ?? '',
        lastUpdated: action.payload?.receivedAt ?? null,
        error: null,
      }
    case types.FETCH_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload ?? 'Unable to load emissions data.',
      }
    case types.REQUEST_DOWNLOAD:
      return {
        ...state,
        downloading: true,
        downloadError: null,
      }
    case types.REQUEST_DOWNLOAD_FULFILLED:
      return {
        ...state,
        downloading: false,
        downloadError: null,
      }
    case types.REQUEST_DOWNLOAD_ERROR:
      return {
        ...state,
        downloading: false,
        downloadError: action.payload ?? 'Unable to download emissions report.',
      }
    default:
      return state
  }
}

export default reducer
